import { FormControl, Validators } from '@angular/forms';
import {
    ErrorMessages,
    GenericCameraSettings,
    GroupEnum,
    InputType,
    PhotoSizeEnum,
    PropertyNames,
    RenderType,
    TabEnum,
    WifiMode,
    WifiModePropertyNames
} from './models';

export const Matrix2Props: GenericCameraSettings[] = [
    //WIFI GLobal Setting//
    {
        groupId: GroupEnum.Wi_Fi_Global_Settings,
        orderindex: 1,
        propertyName: PropertyNames.WifiMode[0],
        displayName: PropertyNames.WifiMode[1],
        render: true,
        value: 1,
        defaultValue: 1,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            {
                value: 0,
                text: 'Off'
            },
            {
                value: 1,
                text: 'On'
            }
        ],
        size: 4,

        effects: [
            {
                propertyNames: WifiModePropertyNames,
                givenValues: [1],
                disabled: false
            },

            {
                propertyNames: WifiModePropertyNames,
                givenValues: [0],
                disabled: true
            }
        ]
    },
    {
        groupId: GroupEnum.Wi_Fi_Global_Settings,
        orderindex: 2,
        propertyName: PropertyNames.WifiConnectionMode[0],
        displayName: PropertyNames.WifiConnectionMode[1],
        render: true,
        value: 1,
        defaultValue: 1,
        size: 4,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            { value: WifiMode.Station, text: 'Station' },
            { value: WifiMode.WifiDirect, text: 'Wi-Fi Direct' }
        ],

        effects: [
            {
                givenValues: [WifiMode.Station],
                propertyNames: [PropertyNames.Ssid[0], PropertyNames.STA_AutoGetIP[0], PropertyNames.STPassword[0]],
                disabled: false
            },
            {
                givenValues: [WifiMode.Station],
                propertyNames: [
                    PropertyNames.WIFI_ConnectTimeout[0],
                    'P2PPinCode'
                ],
                disabled: true
            },
            {
                givenValues: [WifiMode.WifiDirect],
                propertyNames: [
                    PropertyNames.WIFI_ConnectTimeout[0],
                    'P2PPinCode'
                ],
                disabled: false
            },
            {
                givenValues: [WifiMode.WifiDirect],
                propertyNames: [PropertyNames.Ssid[0], PropertyNames.STA_AutoGetIP[0], PropertyNames.STPassword[0]],
                disabled: true
            }
        ]
    },
    {
        groupId: GroupEnum.Wi_Fi_Global_Settings,
        orderindex: 3,
        propertyName: PropertyNames.WIFI_ConnectTimeout[0],
        displayName: PropertyNames.WIFI_ConnectTimeout[1],
        render: true,
        value: 0,
        defaultValue: 0,
        size: 4,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            { text: 'Off', value: 0 },
            { text: '1 min', value: 1 },
            { text: '3 mins', value: 2 },
            { text: '5 mins', value: 3 },
            { text: '10 mins', value: 4 },
            { text: '30 mins', value: 5 }
        ]
    },
    // {
    //     groupId: GroupEnum.Wi_Fi_Global_Settings,
    //     propertyName: PropertyNames.DataEncryption[0],
    //     displayName: PropertyNames.DataEncryption[1],
    //     render: true,
    //     value: '',
    //     defaultValue: '',
    //     size: 4,
    //     inputType: InputType.Number,
    //     renderType: RenderType.Dropdown,
    //     renderTypeValues: [
    //         {value: 0, text: 'No encryption'},
    //         {value: 1, text: 'Encrypt file only'},
    //         {value: 2, text: 'Encrypt streaming only'},
    //         {value: 3, text: 'Encrypt both file and streaming'}
    //     ]
    // },
    /////////////////////
    //Network Configuration
    {
        groupId: GroupEnum.Network_Configuration,
        orderindex: 1,
        propertyName: PropertyNames.Ssid[0],
        displayName: PropertyNames.Ssid[1],
        render: true,
        value: '',
        size: 4,
        defaultValue: '',
        inputType: InputType.Text,
        renderType: RenderType.TextBox,
        validations: [Validators.required, Validators.pattern('^[ -~]+$')],
        validationErrorMessages: {
            required: ErrorMessages.Ssid_required,
            pattern: ErrorMessages.Ssid_Pattern
        }
    },
    {
        groupId: GroupEnum.Network_Configuration,
        orderindex: 2,
        propertyName: PropertyNames.STPassword[0],
        displayName: PropertyNames.STPassword[1],
        render: true,
        value: '',
        size: 4,
        defaultValue: '',
        inputType: InputType.Password,
        renderType: RenderType.TextBox,
        validations: [Validators.pattern('^[ -~]{8,32}$')],
        validationErrorMessages: {
            pattern: ErrorMessages.STPassword_Pattern,
            required: ErrorMessages.STPassword_Required
        }
    },
    {
        groupId: GroupEnum.Network_Configuration,
        orderindex: 3,
        propertyName: PropertyNames.UpdateCertificate[0],
        displayName: PropertyNames.UpdateCertificate[1],
        render: true,
        value: 0,
        size: 4,
        defaultValue: 0,
        inputType: InputType.Number,
        renderType: RenderType.Toggle
    },
    {
        groupId: GroupEnum.Network_Configuration,
        orderindex: 4,
        propertyName: PropertyNames.WifiDirectPin[0],
        displayName: PropertyNames.WifiDirectPin[1],
        render: true,
        value: '',
        size: 4,
        defaultValue: '',
        inputType: InputType.Text,
        renderType: RenderType.TextBox,
        validations: [Validators.pattern('^[0-9]{8,8}$')],
        validationErrorMessages: {
            pattern: ErrorMessages.P2PPinCode_Pattern
        }
    },
    //////////////////////
    //Notifications//
    {
        groupId: GroupEnum.Notifications,
        orderindex: 1,
        propertyName: PropertyNames.LEDLight[0],
        displayName: PropertyNames.LEDLight[1],
        render: true,
        value: 1,
        size: 4,
        defaultValue: 1,
        inputType: InputType.Number,
        renderType: RenderType.Toggle
    },
    {
        groupId: GroupEnum.Notifications,
        orderindex: 2,
        propertyName: PropertyNames.ShockReminding[0],
        displayName: PropertyNames.ShockReminding[1],
        render: true,
        value: 1,
        size: 4,
        defaultValue: 1,
        inputType: InputType.Number,
        renderType: RenderType.Toggle
    },
    {
        groupId: GroupEnum.Notifications,
        orderindex: 3,
        propertyName: PropertyNames.BeepSound[0],
        displayName: PropertyNames.BeepSound[1],
        render: true,
        value: 1,
        size: 4,
        defaultValue: 1,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            { text: 'Off', value: 0 },
            { text: 'Beep', value: 1 }
            // {text: 'Sound', value: 2}
        ]
    },
    {
        groupId: GroupEnum.Notifications,
        orderindex: 4,
        propertyName: PropertyNames.StealthMode[0],
        displayName: PropertyNames.StealthMode[1],
        render: true,
        value: 0,
        size: 4,
        defaultValue: 0,
        inputType: InputType.Number,
        renderType: RenderType.Toggle
    },
    {
        groupId: GroupEnum.Notifications,
        orderindex: 5,
        propertyName: PropertyNames.RecordingNotification[0],
        displayName: PropertyNames.RecordingNotification[1],
        render: true,
        value: 0,
        size: 4,
        defaultValue: 0,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            { text: 'Off', value: 0 },
            { text: 'Beep every 5 secs', value: 1 },
            { text: 'Beep every 10 secs', value: 2 },
            { text: 'Beep every 15 secs', value: 3 },
            { text: 'Beep every 30 secs', value: 4 },
            { text: 'Beep every 60 secs', value: 5 }
        ]
    },
    //Low-light recording//
    {
        groupId: GroupEnum.Low_light_recording,
        orderindex: 1,
        propertyName: PropertyNames.IRMode[0],
        displayName: PropertyNames.IRMode[1],
        render: true,
        value: 3,
        size: 4,
        defaultValue: 3,
        inputType: InputType.Text,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            { text: 'Off', value: 0 },
            // {text: 'Manual', value: 1},
            { text: 'During recording', value: 2 },
            { text: 'Auto', value: 3 }
        ]
    },
    //////////////////////////////////
    //GPS//
    {
        groupId: GroupEnum.GPS,
        orderindex: 1,
        propertyName: PropertyNames.LocationService[0],
        displayName: PropertyNames.LocationService[1],
        render: true,
        value: 0,
        size: 4,
        defaultValue: 0,
        inputType: InputType.Boolean,
        renderType: RenderType.Toggle
    },
    ////////////////
    //Text Overlay//
    {
        groupId: GroupEnum.Text_Overlay,
        orderindex: 1,
        propertyName : PropertyNames.EnableWatermark[0],
        displayName: PropertyNames.EnableWatermark[1],
        render: false,
        value: 0,
        size: 4,
        defaultValue: 0,
        inputType: InputType.Number,
        renderType: RenderType.Toggle
    },
    {
        groupId: GroupEnum.Text_Overlay,
        orderindex: 2,
        propertyName : PropertyNames.BurnText[0],
        displayName: PropertyNames.BurnText[1],
        render: true,
        value: '',
        defaultValue: '',
        size: 4,
        inputType: InputType.Text,
        renderType: RenderType.TextBox
    },
    ////////////////
    //Video Format//
    {
        groupId: GroupEnum.Video_Format,
        orderindex: 1,
        propertyName: PropertyNames.OutputTV[0],
        displayName: PropertyNames.OutputTV[1], //TV Output
        render: true,
        value: 0,
        size: 4,
        defaultValue: 0,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            { text: 'NTSC', value: 0 },
            { text: 'PAL', value: 1 }
        ]
    },
    ////////////////
    //Recording Settings//
    {
        groupId: GroupEnum.Recording_Settings,
        orderindex: 1,
        propertyName: PropertyNames.RecordingSize[0],
        displayName: PropertyNames.RecordingSize[1],
        render: true,
        value: 6,
        size: 4,
        defaultValue: 6,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            { text: '1920X1080@30fps', value: 6 },
            { text: '1280X720@30fps', value: 11 },
            { text: '848X480@30fps', value: 13 }
        ]
    },
    {
        groupId: GroupEnum.Recording_Settings,
        orderindex: 2,
        propertyName: PropertyNames.RecordingQuality[0],
        displayName: PropertyNames.RecordingQuality[1],
        render: true,
        value: 0,
        size: 4,
        defaultValue: 0,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            { text: 'High', value: 0 },
            { text: 'Medium', value: 1 },
            { text: 'Low', value: 2 }
        ]
    },
    {
        groupId: GroupEnum.Recording_Settings,
        orderindex: 3,
        propertyName: PropertyNames.RecordingTime[0],
        displayName: PropertyNames.RecordingTime[1],
        render: true,
        value: 4,
        size: 4,
        defaultValue: 4,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            { text: '5 mins', value: 4 },
            { text: '10 mins', value: 5 },
            { text: '15 mins', value: 6 }
        ]
    },
    //////////////////////
    //Streaming Setting///
    {
        groupId: GroupEnum.Streaming_Settings,
        orderindex: 1,
        propertyName: PropertyNames.StreamingResolution[0],
        displayName: PropertyNames.StreamingResolution[1],
        render: true,
        value: 1,
        size: 4,
        defaultValue: 1,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            { text: '1280X720', value: 1 },
            { text: '848X480', value: 2 },
            { text: '432X240', value: 3 }
        ]
    },
    {
        groupId: GroupEnum.Streaming_Settings,
        orderindex: 2,
        propertyName: PropertyNames.StreamingBitrate[0],
        displayName: PropertyNames.StreamingBitrate[1],
        render: true,
        value: 0,
        size: 4,
        defaultValue: 0,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            { text: '5000 Kbps', value: 0 },
            { text: '4000 Kbps', value: 1 },
            { text: '3000 Kbps', value: 2 },
            { text: '2000 Kbps', value: 3 },
            { text: '1000 Kbps', value: 4 },
            { text: '500 Kbps', value: 5 },
            { text: '300 Kbps', value: 6 }
        ]
    },
    //////////////////////
    //Pre and Post Recording//
    {
        groupId: GroupEnum.Pre_and_Post_Recording,
        orderindex: 1,
        propertyName: PropertyNames.PreRecordingTime[0],
        displayName: PropertyNames.PreRecordingTime[1],
        render: true,
        value: 0,
        size: 4,
        defaultValue: 0,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            { text: 'Off', value: 0 },
            { text: '5 secs', value: 1 },
            { text: '10 secs', value: 2 },
            { text: '15 secs', value: 3 },
            { text: '20 secs', value: 4 },
            { text: '30 secs', value: 5 },
            { text: '60 secs', value: 6 },
            { text: '120 secs', value: 7 }
        ]
    },
    {
        groupId: GroupEnum.Pre_and_Post_Recording,
        orderindex: 2,
        propertyName: PropertyNames.VideoMute[0],
        displayName: PropertyNames.VideoMute[1],
        render: true,
        value: 0,
        size: 4,
        defaultValue: 0,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            { text: 'Off', value: 0 },
            { text: 'On', value: 1 },
            { text: 'Pre-recorded only', value: 2 }
        ]
    },
    //////////////////////////
    //Other Settings//
    //////////////////
    {
        groupId: GroupEnum.Other_Settings_2,
        orderindex: 1,
        propertyName: PropertyNames.PowerOff[0],
        displayName: PropertyNames.PowerOff[1],
        render: true,
        value: 0,
        size: 4,
        defaultValue: 0,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            { text: 'Off', value: 0 },
            // {text: '0 sec', value: 7},
            { text: '30 secs', value: 1 },
            { text: '1 min', value: 2 },
            { text: '3 mins', value: 3 },
            { text: '5 mins', value: 4 },
            { text: '10 mins', value: 5 },
            { text: '30 mins', value: 6 }
        ]
    },
    {
        groupId: GroupEnum.Other_Settings_2,
        orderindex: 2,
        propertyName: PropertyNames.AutoDetection[0],
        displayName: PropertyNames.AutoDetection[1],
        render: true,
        value: 0,
        size: 4,
        defaultValue: 0,
        inputType: InputType.Number,
        renderType: RenderType.Toggle
    },
    //////////////////
    //Image Quality//
    {
        groupId: GroupEnum.Image_Quality,
        orderindex: 1,
        propertyName: PropertyNames.PhotoSize[0],
        displayName: PropertyNames.PhotoSize[1],
        render: true,
        value: 4,
        size: 4,
        defaultValue: 4,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            { text: '16 MP', value: PhotoSizeEnum.PHOTO_SIZE_16M },
            { text: '12 MP', value: PhotoSizeEnum.PHOTO_SIZE_12M },
            { text: '8 MP', value: PhotoSizeEnum.PHOTO_SIZE_8M },
            { text: '4 MP', value: PhotoSizeEnum.PHOTO_SIZE_4M }
        ]
    },
    //////////////////
    //Image Capture///
    {
        groupId: GroupEnum.Image_Capture,
        orderindex: 1,
        propertyName: PropertyNames.SelfieTime[0], //Selfie Mode
        displayName: PropertyNames.SelfieTime[1],
        render: true,
        value: 0,
        size: 4,
        defaultValue: 0,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            { text: 'Off', value: 0 },
            { text: '3 secs', value: 1 },
            { text: '5 secs', value: 2 },
            { text: '10 secs', value: 3 }
        ]
    },
    {
        groupId: GroupEnum.Image_Capture,
        orderindex: 2,
        propertyName: PropertyNames.BurstMode[0],
        displayName: PropertyNames.BurstMode[1],
        render: true,
        value: 0,
        size: 4,
        defaultValue: 0,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            { text: 'Off', value: 0 },
            { text: '3 photos every button press', value: 2 },
            { text: '5 photos every button press', value: 3 }
        ]
    }
    //////////////////
];
